import { render, staticRenderFns } from "./CustomOption.vue?vue&type=template&id=0c67ff8d&scoped=true&"
import script from "./CustomOption.vue?vue&type=script&lang=js&"
export * from "./CustomOption.vue?vue&type=script&lang=js&"
import style0 from "./CustomOption.vue?vue&type=style&index=0&id=0c67ff8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c67ff8d",
  null
  
)

export default component.exports